export const DATA_AUTOMATION_COMPANY_DOMAINS_SUMMARY = "company-domains-summary";

export const DATA_AUTOMATION_COMPANY_DOMAIN_SINGLE = "company-domains-single";
